import { render, staticRenderFns } from "./IntanDetails.vue?vue&type=template&id=086f608e&scoped=true&"
import script from "./IntanDetails.vue?vue&type=script&lang=js&"
export * from "./IntanDetails.vue?vue&type=script&lang=js&"
import style0 from "./IntanDetails.vue?vue&type=style&index=0&id=086f608e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086f608e",
  null
  
)

export default component.exports